/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'material/ctas/signin/signin_styles';



/* ========== ~~~~~~~~~~ CTA : SIGN IN ~~~~~~~~~~ ========== */
const SignInCTA = (props) => {
	return (
		<div className={`cta signincta ${props.classes.signincta}`}>
	        <p>{props.copy} <Link type={`internal`} action={`auth/signin`} text={`Sign In`} /></p>
	    </div>
	);
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SignInCTA);
